import React from 'react';
import NavigationBar from './NavigationBar';
import { useIsEmbedded } from '@/hooks/embed/useEmbedMode';
import EmbeddedDevPanelTrigger from '@/components/DevPanel/EmbeddedDevPanelTrigger';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isEmbedded = useIsEmbedded();

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {!isEmbedded && <NavigationBar />}
      {isEmbedded && <EmbeddedDevPanelTrigger />}
      <div className="flex-1 min-h-0 overflow-hidden">{children}</div>
    </div>
  );
};

export default Layout;
